import React from 'react';
import { Loader2, Plus } from 'lucide-react';

export default function BookingCreateForm({
  form,
  setForm,
  creating,
  connected,
  configured,
  onCreate,
}) {
  return (
    <section className="border border-[#E3E2E0] rounded-xl p-5 bg-white" data-testid="booking-create">
      <div className="flex items-center gap-2 mb-4">
        <Plus className="w-4 h-4 text-[#6B6B6B]" />
        <h2 className="text-sm font-semibold text-[#191919]">Create booking</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <input
          value={form.title}
          onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
          placeholder="Title"
          className="px-3 py-2 bg-[#FBFBFA] border border-[#E3E2E0] rounded-lg text-sm"
          data-testid="booking-title"
        />
        <input
          value={form.attendees}
          onChange={(e) => setForm((prev) => ({ ...prev, attendees: e.target.value }))}
          placeholder="Attendees, comma separated"
          className="px-3 py-2 bg-[#FBFBFA] border border-[#E3E2E0] rounded-lg text-sm"
          data-testid="booking-attendees"
        />
        <input
          type="datetime-local"
          value={form.start_at}
          onChange={(e) => setForm((prev) => ({ ...prev, start_at: e.target.value }))}
          className="px-3 py-2 bg-[#FBFBFA] border border-[#E3E2E0] rounded-lg text-sm"
          data-testid="booking-start"
        />
        <input
          type="datetime-local"
          value={form.end_at}
          onChange={(e) => setForm((prev) => ({ ...prev, end_at: e.target.value }))}
          className="px-3 py-2 bg-[#FBFBFA] border border-[#E3E2E0] rounded-lg text-sm"
          data-testid="booking-end"
        />
        <textarea
          value={form.description}
          onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))}
          placeholder="Description"
          rows={3}
          className="md:col-span-2 px-3 py-2 bg-[#FBFBFA] border border-[#E3E2E0] rounded-lg text-sm resize-none"
          data-testid="booking-description"
        />
      </div>
      <button
        onClick={onCreate}
        disabled={creating || !connected || !form.title || !form.start_at || !form.end_at}
        title={!connected ? 'Connect Google Calendar first.' : 'Create booking'}
        className="mt-3 inline-flex items-center gap-2 px-3.5 py-2 bg-[#0A0A0A] text-white rounded-lg text-sm font-medium hover:bg-[#2D2D2D] disabled:cursor-not-allowed disabled:bg-[#9B9B9B] disabled:text-white disabled:opacity-100"
        data-testid="booking-create-btn"
      >
        {creating ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
        {connected ? 'Create booking' : 'Connect Google to create booking'}
      </button>
      {!connected && configured !== false && (
        <p className="mt-2 text-xs text-[#6B6B6B]">
          Each client needs to connect their own Google Calendar before bookings can be created.
        </p>
      )}
    </section>
  );
}
